export enum InvoiceStatus {
    Ninguno = 0,
    Pendiente = 1,
    Pagada = 2,
    Vencida = 3,
    Cancelada = 4
/**
 * 
 *  None = 0,
 Registered = 1,
 Completed = 2,
 InProcess = 3,
 Canceled = 4,
 Pending = 5,
 Rejected = 6,
 Failure = 7
 */
}